<template>
  <div class="border-top mt-1 pt-1 small-text">
    <VitalSignsSummary :readings="readings" />
    <div v-if="ackDt" class="text-success">
      ✓ รับทราบก่อนรักษา · {{ ackDoctorName }} {{ time(ackDt) }}
    </div>
    <b-link v-if="!adding" class="small-text" @click="adding = true"
      >+ วัด vital</b-link
    >
    <div v-else class="mt-1">
      <VitalSignsForm v-model="draft" :id-prefix="idPrefix" />
      <div class="d-flex justify-content-end mt-1">
        <b-button size="sm" variant="link" @click="cancel">ยกเลิก</b-button>
        <b-button
          size="sm"
          variant="outline-info"
          :disabled="isSaving"
          @click="save"
          >บันทึก</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { eventBus } from "@/main";
import VitalSignsForm from "@/components/aaci/VitalSignsForm";
import VitalSignsSummary from "@/components/aaci/VitalSignsSummary";
import { emptyReading, toPayload, validateReadings } from "@/utils/vitalSigns";

export default {
  name: "CheckinVitalsPanel",
  components: { VitalSignsForm, VitalSignsSummary },
  props: {
    appointmentId: { type: Number, default: null },
    readings: { type: Array, default: () => [] },
    ackDt: { type: [String, Date], default: null },
    ackDoctorName: { type: String, default: "" },
    idPrefix: { type: String, default: "ph" },
  },
  data() {
    return { adding: false, draft: [emptyReading()], isSaving: false };
  },
  methods: {
    time(dt) {
      return dt ? moment(dt).format("HH:mm") : "";
    },
    cancel() {
      this.adding = false;
      this.draft = [emptyReading()];
    },
    async save() {
      const readings = toPayload(this.draft);
      const error = readings.length
        ? validateReadings(readings)
        : "กรุณากรอก vital signs อย่างน้อย 1 ค่า";
      if (error) {
        eventBus.$emit("alertToast", { message: error, variant: "warning" });
        return;
      }
      this.isSaving = true;
      try {
        const res = await this.$store.dispatch(
          "moduleAppointment/addVitalSigns",
          {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            appointmentId: this.appointmentId,
            readings,
            source: "TREATMENT",
          }
        );
        this.$emit("update:readings", res.data);
        this.cancel();
      } catch (err) {
        eventBus.$emit("alertToast", {
          message:
            err.response?.data?.errorMessage || "บันทึก vital signs ไม่สำเร็จ",
          variant: "danger",
        });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
